import { render, staticRenderFns } from "./manpowerIndustry.vue?vue&type=template&id=f2a6663e"
import script from "./manpowerIndustry.vue?vue&type=script&lang=js"
export * from "./manpowerIndustry.vue?vue&type=script&lang=js"
import style0 from "./manpowerIndustry.vue?vue&type=style&index=0&id=f2a6663e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports